import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { UnregisterDialogComponent } from "./unregister-dialog.component";
import { Visitor } from "../visitor/visitor";

@Injectable({
  providedIn: "root",
})
export class UnregisterDialogService {
  openDialog(visitor: Visitor): Promise<boolean> {
    const dialogRef = this.dialog.open(UnregisterDialogComponent, {
      // width: "400px",
      data: visitor,
    });

    return dialogRef.afterClosed().toPromise();
  }

  constructor(private dialog: MatDialog) {}
}
